<template>
  <div class="container col-md-8 col-sm-8 col-md-offset-2 col-sm-offset-2">
    <search-car
      @input-changed="selectCar"
      @reset-view="reset_view"
      @localizar="localizar_click"
      >
    </search-car>

    <spinner
      v-if="isProcessing"
      :size="50"
      :line-size="3"
      :speed="0.6"
      :line-fg-color="'magenta'"
      :spacing="6"
      :message="'Procesando información...'"
      :font-size="18"
      :text-fg-color="'#07088E'"
    >
    </spinner>
    <div v-if="show_tracking">
      <change-car
        :car="car"
        :gps="gps"
        :error-gps="errorGps"
        @car-change="carChange"
        :account="account"
        @account-change="accountChange"
      />

      <div class="command-panel">
          <last-position-table
            v-if="lastPosition"
            :timestamp="lastPosition.timestamp"
            :address="lastPosition.address"
            :refresh="refreshCar"
          />
          <fuel-cut
            :vehicle="car"
            @execution-finished="fuelCutCommandFinished()"
          />
      </div>

      <maps
        id="map"
        :last-car-location="lastPosition"
        :signals="currentSignals"
        :markerFocused="markerToFocus"
        :freshSignals="finalSignals"
      />

      <tabs
        style="margin-top: 20px"
        :tabs="['Ultimos reportes', 'Comandos de corte: Log']"
      >
        <location-table
          slot='Ultimos reportes'
          :car="car"
          :current-signals="currentSignals"
          :rows-per-page="rowsPerPageTrack"
          @focus-location="focusLocation"
          @page-change="pageChange"
          @clear-dates="clearDates"
          @change-dates="changeDates"
          @change-geocode-provider="changeGeolocalizationProvider"
        />

        <fuel-cut-history
          slot='Comandos de corte: Log'
          ref="fuelCutHistory"
          :vehicle="car"
        />
      </tabs>

      <map-link
        @enable-map-link="enable_map_link"
        :map-link="mapLink"
        :show-link="showLink"
        :copying="false"
      />

    </div>
  </div>
</template>

<script>
import SearchCar from './SearchCar.vue'
import ChangeCar from './ChangeCar.vue'
import LocationTable from './LocationTable.vue'
import MapLink from './MapLink.vue'
import Maps from '../Dashboard/Views/Maps.vue'
import LastPositionTable from '../UIComponents/LastPositionTable.vue'
import FuelCut from '../UIComponents/FuelCut.vue'
import FuelCutHistory from '../UIComponents/FuelCutHistory.vue'
import Tabs from '../UIComponents/Tabs.vue'
import GoogleMapsLoader from 'google-maps'

import server_config from 'src/server_config.js'
import Spinner from 'vue-simple-spinner'

import AccountService from '../../accountService.js'
import ThingsService from '../../thingsService.js'
import AuthService from '../../authService.js'
import { GeocodeService } from '../../services'

import Utils from 'src/utils'

import { Car, Gps } from '../../models'

// Five days in miliseconds
const DAYS_RANGE = 4.32e+8 //8.64e+8;

export default {
  components: {
    SearchCar,
    ChangeCar,
    LocationTable,
    Spinner,
    MapLink,
    Maps,
    LastPositionTable,
    FuelCut,
    FuelCutHistory,
    Tabs
  },
  data () {
    return {
      car: Car.getNew(),
      gps: Gps.getNew(),
      currentInterval: null,
      dateFrom: null,
      dateTo: null,
      lastSignalReported: null,
      lastPosition: null,
      account: {
        name: '',
        address: null
      },
      isProcessing: false,
      show_tracking: false,
      serverError: null,
      errorGps: false,
      currentSignals: [],
      markerToFocus: null,
      lastSignalTimestamp: null,
      freshSignals: null,

      rowsPerPageTrack: 15,
      currentPageTrack: 1,
      finalSignals: null,

      mapLink: '',
      showLink: false
    }
  },

  created: function () {
    AuthService.redirectToLoginIfNeeded(this.$router)
    GoogleMapsLoader.KEY = server_config.google_key
    GoogleMapsLoader.load()
  },

  methods: {
    update: function() {
      alert(JSON.stringify(this.currentSignals,undefined,2))
    },
    selectCar: function (car) {
      this.car = car
      this.show_tracking = false
    },
    localizar_click: async function () {
      this.clearDates()
      this.currentPageTrack = 1
      this.isProcessing = true
      this.lastSignalReported = null
      await this.get_car_gps()
      this.currentSignals = []
      this.finalSignals = []
      this.lastSignalTimestamp = null
      this.setLastPosition();
    },

    reset_view: function () {
      this.show_tracking = false
      this.errorGps = false;
      this.car = Car.getNew()
      this.gps = Gps.getNew()
      this.cancelCurrentInterval()
    },

    add_fields: function (signals) {
      signals.forEach(element => {
        element.address = ' '
        element.antenna_state_ok = false
        element.online_timestamp = 0
      })
    },

    async getSignals () {
      try {
        await this.find_user_from_car(this.car)
        if (this.dateFrom == null && this.dateTo == null) {
          await this.doFindSignals()
          this.setSignalRefreshInterval()
        } else {
          this.cancelCurrentInterval();
          this.currentSignals = await this.getSignalsRange()
        }
        setTimeout(this.now_show_tracking, 5000)
      } catch (error) {
        alert('getSignals catch: ' + JSON.stringify(error, undefined, 2))
        setTimeout(this.now_show_tracking, 5000)
      }
    },

    async doFindSignals () {
      let partSignals = await this.doGetSignals()
      partSignals.map( (element, index) => {
        element.index = element.event_timestamp
      })
      this.add_fields(partSignals)
      partSignals = this.filterDayDifference(partSignals)
      this.freshSignals = this.filterFreshSignals(partSignals)
      await Promise.all(this.freshSignals.map(this.complete_signal_json))
      this.currentSignals = this.freshSignals.concat(this.currentSignals)
    },

    async doGetSignals () {
      const now = Date.now();
      const lastSignal = await this.getLastSignalTimestamp()
      if (lastSignal != null)
        this.lastSignalReported = lastSignal

      const to = this.lastSignalReported != null && this.lastSignalReported <= now ? this.lastSignalReported : now
      const parameters = {
        _to: to,
        _from: to - DAYS_RANGE,
        _page: this.currentPageTrack,
        _limit: this.rowsPerPageTrack
      }

      let response = await ThingsService.thingSignals(this.car.id, parameters)
      //console.log('signals length: ' + response.body.length)
      return response.body;
    },

    async getSignalsRange () {
      const parameters = {
        _to: this.dateTo,
        _from: this.dateFrom,
        _page: this.currentPageTrack,
        _limit: this.rowsPerPageTrack
      }

      let response = (await ThingsService.thingSignals(this.car.id, parameters)).body
      this.add_fields(response)
      response.map( (element, index) => {
        element.index = element.event_timestamp
      })
      await Promise.all(response.map(this.complete_signal_json))
      return response
    },

    clearDates() {
      this.currentSignals = []
      this.dateFrom = null
      this.dateTo = null
      this.lastSignalTimestamp = null
      this.lastPosition = null,
      this.getSignals()
    },

    changeDates(dateFrom, dateTo) {
      this.currentSignals = []
      this.dateFrom = dateFrom.getTime()
      // The magic number is one day in millisecs
      this.dateTo = dateTo.getTime() + 8.64e+7;
      this.lastSignalTimestamp = null
      this.getSignals()
    },

    cancelCurrentInterval() {
      if (this.currentInterval != null) {
        clearInterval(this.currentInterval)
      }
    },

    setSignalRefreshInterval()  {
      // Cancel previous interval
      this.cancelCurrentInterval()
      this.currentInterval = setInterval(async () => await this.doFindSignals(), 5000)
    },

    filterDayDifference (signals) {
      if (signals.length === 0) {
        return []
      }
      var finalSignals = []
      var first = new Date(signals[0].event_timestamp)
      for (var index = 0; index < signals.length; index++) {
        var current = new Date(signals[index].event_timestamp)
        var difference = Math.trunc(Math.abs((first.getTime() - current.getTime()) / 1000))
        if (difference < 172800) { // 172800 seconds are 48 hours
          finalSignals.push(signals[index])
        } else {
          break
        }
      }
      return finalSignals
    },

    filterFreshSignals (signals) {
      if (signals.length === 0) {
        return []
      }
      var freshSignals = []
      if (this.lastSignalTimestamp !== null) {
        for (var index = 0; index < signals.length; index++) {
          if (signals[index].event_timestamp > this.lastSignalTimestamp) {
            freshSignals.push(signals[index])
          } else {
            break
          }
        }
      } else {
        freshSignals = signals
      }
      this.lastSignalTimestamp = signals[0].event_timestamp
      return freshSignals
    },

    now_show_tracking: function () {
      this.isProcessing = false
      this.show_tracking = true
    },

    find_user_from_car: async function (car) {
      try {
        let response = await AccountService.findById(car.account_id)
        this.account = response.body
      } catch (error) {
        alert('getSignals catch: ' + JSON.stringify(error, undefined, 2))
      }
    },

    handle_error: function (error) {
      this.serverError = error
    },

    get_car_gps: async function () {
      try {
        this.lastSignalReported = this.car.metadata.state != null && this.car.metadata.state.location != null
        ? this.car.metadata.state.location.timestamp
        : null;

        if(this.car.things.length > 0) {
          let responseGps = await ThingsService.fetch(this.car.things[0])
          if (responseGps.body.type === 'mrn:things:gps') {
            this.gps = responseGps.body
          }
          else {
            this.errorGps = true
          }
        }
      }
      catch (error) {
        let failureText = 'Error buscando gps. Reintente o contacte al administrador.'
        if(error.body){
          failureText = error.body.description
        }
        this.errorGps = true
        this.handle_error({body: {message: failureText}})
      }
    },

// ====================================================
// Functions to complete the json with calculated
// data for the table or map
// ====================================================

    complete_signal_json: async function (signal_json, index) {
      if (signal_json.address === ' ') {
        await this.coordinates_to_address(signal_json, index)
      }
      if (signal_json.antenna_state_ok === false){
        this.antenna_state(signal_json)
      }
      if (signal_json.online_timestamp === 0) {
        this.set_online(signal_json)
      }
      this.format_datetime(signal_json)
    },

    format_datetime: function (signal_json) {
        var options = { weekday: 'short', year: 'numeric', month: 'long', day:'numeric', hour:'numeric', minute:'numeric', second:'numeric'}
        var date = new Date(signal_json.event_timestamp)
        signal_json.datetime = date.toLocaleDateString('es-ES', options)
    },

    coordinates_to_address: async function(signal_json, index) {
      try {
        let response = await GeocodeService.reverseGeocode(signal_json.latitude, signal_json.longitude)
        signal_json.address = response != null ? `${response}` : "Error al geocodificar la dirección"
        return signal_json.address;
      } catch (error) {
        console.log(error)
        console.log('error geocode' + JSON.stringify(error, undefined, 2))
        signal_json.address = "Error al geocodificar la dirección"
        return signal_json.address;
      }
    },

    antenna_state: function (signal_json) {
  // signal.event_timestamp - signal.fix_timestamp > X (por defecto 255 segundos) significa colgada
  // True := Antena ok | False := Antena colgada
      signal_json.antenna_state_ok = (signal_json.event_timestamp - signal_json.fix_timestamp) * 0.001 < 255
    },

    set_online: function (signal_json) {
      // return the difference time in seconds
      signal_json.online_timestamp = (signal_json.ingestion_timestamp - signal_json.event_timestamp) * 0.001
    },

// =========================================
// =========================================

    coordinates_to_link: function (lat,lng) {
      return 'https://www.google.com/maps/search/?api=1&query=' + lat +','+ lng
    },

    enable_map_link: function () {
      var lat = this.currentSignals[0].latitude
      var lng = this.currentSignals[0].longitude
      this.mapLink = this.coordinates_to_link(lat,lng)
      this.showLink = true
    },

    focusLocation: function (id) {
      this.markerToFocus = id
    },

    carChange (newCar) {
      this.car = newCar
      this.setLastPosition();
    },

    async refreshCar() {
      if (this.car == null || this.car.id == null) {
        return
      }
      const response = await ThingsService.fetch(`${this.car.id}?_include=child_things`);
      this.car = response.body;
      this.setLastPosition();
    },

    async setLastPosition() {
      try {
        const location = {
          latitude: this.car.state.location.coordinates[0],
          longitude: this.car.state.location.coordinates[1]
        }
        this.lastPosition = {
          location,
          address: await this.coordinates_to_address(location, 0),
          timestamp: this.car.metadata.state.location.timestamp,
        }
      } catch(error) {
          console.error("Hubo un error obteniendo la ultima ubicacion del auto.")
      }
    },

    accountChange (newAccount) {
      this.account = newAccount
    },

    async pageChange (newPage) {
      this.currentPageTrack = newPage
      this.currentSignals = []
      this.finalSignals = []
      this.lastSignalTimestamp = null
      await this.getSignals()
    },

    async changeGeolocalizationProvider(provider) {
      GeocodeService.setProvider(provider);
      this.isProcessing = true
      this.currentSignals = []
      this.finalSignals = []
      this.lastSignalTimestamp = null
      await this.getSignals()
      this.isProcessing = false
      console.log(provider);
    },

    async getLastSignalTimestamp()  {
      try {
        if (this.account.services != undefined && this.account.services['mrn:service:vehicle_lite'] != undefined) {
          const lastSignal = await ThingsService.fetchLatestSignal(this.car.id)
          return lastSignal != null ? lastSignal.body.event_timestamp : null
        } else {
          const lastSignal = await ThingsService.fetch(this.car.id, { _p: 'metadata.state.location.timestamp' })
          return lastSignal != null ? lastSignal.body.metadata.state.location.timestamp : null
        }
      } catch (error) {
        console.error(`There was an error fetching the last signal timestmap\n${error}`)
        return null
      }
    },

    fuelCutCommandFinished() {
      this.refreshCar()
      if (Object.keys(this.$refs).includes('fuelCutHistory')) {
        this.$refs.fuelCutHistory.refreshFirstPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.command-panel {
  display: flex;

  >* {
    flex: 1 1 0;
  }
}
</style>



// WEBPACK FOOTER //
// TrackCar.vue?a9df763e